<template>
    <div class="row company">
        <!-- TABS -->
        <div class="col-12 w-100">
            <div class="tabs p-2 py-3">
                <ul class="nav nav-pills custom-pills gap-3 mx-2 justify-content-center">
                    <li class="nav-item">
                        <a class="nav-link" :class="{ active: activeTab === 'zakladni' }"
                            @click.prevent="activeTab = 'zakladni'">
                            {{ $t('company.basicInfo') }}
                        </a>
                    </li>
                    <li class="nav-item">
                        <a v-if="actualOWnersCount > 0 || oldOwnersCount > 0 || company.dph || jobPositions.length > 0 || companyAddress.length > 0 || company.insolvencies"
                            class="nav-link" :class="{ active: activeTab === 'pokrocile' }"
                            @click.prevent="activeTab = 'pokrocile'">
                            {{ $t('company.moreInfo') }}
                        </a>

                        <a v-else class="nav-link disabled">
                            {{ $t('company.moreInfo') }}
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" :class="{ active: activeTab === 'vase' }"
                            @click.prevent="activeTab = 'vase'">
                            {{ $t('company.yourInfo') }}
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" :class="{ active: activeTab === 'kontakty' }"
                            @click.prevent="activeTab = 'kontakty'">
                            {{ $t('navbar.contacts') }}
                        </a>
                    </li>
                    <li class="nav-item">
                        <a v-if="institution.max_storage" class="nav-link"
                            :class="{ active: activeTab === 'dokumenty' }" @click.prevent="activeTab = 'dokumenty'">
                            {{ $t('company.documents') }}
                        </a>
                        <a v-else class="nav-link disabled">
                            {{ $t('company.documents') }}
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" :class="{ active: activeTab === 'udalosti' }"
                            @click.prevent="activeTab = 'udalosti'">
                            {{ $t('company.events') }}
                        </a>
                    </li>
                </ul>
            </div>
        </div>

        <!-- Error / Loading -->
        <div v-if="error" class="my-2 text-center" style="font-size: 40px; color: red;">
            <span class="error">{{ error }}</span>
        </div>
        <div v-if="loading" class="loading-container text-center loading-company">
            <SpinningWheel class="mb-3 mx-auto" />
        </div>

        <div class="tab-content">
            <!-- Základní údaje -->
            <div v-if="activeTab === 'zakladni'" class="row mt-3">
                <div class="col-12">
                    <CompanyBasicInfo :company="company" :companyAddress="companyAddress" />
                </div>
                <div class="col-12 col-xl-6 mt-3"
                    :class="{ hidden: !(company.trades?.length > 0) && !(company.dph?.length > 0) }">
                    <CompanyTrades class="" :company="company" />
                </div>
                <div class="col-12 col-xl-6 mt-3">
                    <CompanyBasicCapital class="" :company="company" />
                </div>
                <div class="col-12 col-xl-6 mt-3">
                    <CompanyDph class="" :company="company" />
                </div>
                <div class="col-12 col-xl-6 mt-3" v-if="company.criminal_record">
                    <CompanyCriminalRecord class="" :company="company" />
                </div>
            </div>

            <!-- Pokročilé údaje -->
            <div v-if="activeTab === 'pokrocile'" class="row">
                <div class="col-12 mt-3" v-if="actualOWnersCount > 0 || oldOwnersCount > 0">
                    <CompanyOwners :company="company" :actualOWnersCount="actualOWnersCount"
                        :oldOwnersCount="oldOwnersCount" />
                </div>
                <div class="col-12 mt-3">
                    <CompanyBankAcc :company="company" />
                </div>
                <div v-if="jobPositions.length > 0" class="col-12 col-xl-6 mt-3">
                    <CompanyJobPositions :jobPositions="jobPositions" />
                </div>
                <!-- <div class="col-12 col-xl-6 mt-3">
                    <CompanyExecutions :company="company" />
                </div> -->
                <div class="col-12 col-xl-6 mt-3">
                    <CompanyEstablishments :company="company" :companyAddress="companyAddress" />
                </div>
                <div class="col-12 col-xl-6 mt-3">
                    <CompanyInsolvency class="" :company="company" :loading="loading" @reload="loadData" />
                </div>
            </div>

            <!-- Vaše informace -->
            <div v-if="activeTab === 'vase'" class="row">
                <div class="mt-3 col-12 col-xl-6">
                    <CompanyYourInfo :company="company" :tags="tags" @reload="loadData" />
                </div>
                <div class="mt-3 col-12 col-xl-6">
                    <CompanyNotes :company="company" @reload="loadData" />
                </div>
            </div>

            <!-- Kontakty -->
            <div v-if="activeTab === 'kontakty'" class="mt-3">
                <CompanyContacts :company="company" :contacts="contacts" @reload="loadData" />
            </div>
            <!-- Dokumenty -->
            <div v-if="activeTab === 'dokumenty'" class="mt-3">
                <CompanyDocuments :company="company" />
            </div>

            <!-- Údalosti -->
            <div v-if="activeTab === 'udalosti'" class="mt-3">
                <CompanyEvents :company="company" :events="events" @reload="loadData" />
            </div>
        </div>
    </div>
</template>

<script>
import CompanyBasicInfo from '@/components/CompanyDetail/CompanyBasicInfo.vue';
import CompanyOwners from '@/components/CompanyDetail/CompanyOwners.vue';
import CompanyDph from '@/components/CompanyDetail/CompanyDph.vue';
import CompanyBankAcc from '@/components/CompanyDetail/CompanyBankAcc.vue';
import CompanyTrades from '@/components/CompanyDetail/CompanyTrades.vue';
import CompanyYourInfo from '@/components/CompanyDetail/CompanyYourInfo.vue';
import CompanyNotes from '@/components/CompanyDetail/CompanyNotes.vue';
import CompanyExecutions from '@/components/CompanyDetail/CompanyExecutions.vue';
import CompanyInsolvency from '@/components/CompanyDetail/CompanyInsolvency.vue';
import CompanyBasicCapital from '@/components/CompanyDetail/CompanyBasicCapital.vue';
import CompanyEstablishments from '@/components/CompanyDetail/CompanyEstablishments.vue';
import CompanyDocuments from '@/components/CompanyDetail/CompanyDocuments.vue';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import SpinningWheel from '@/components/SpinningWheel.vue';
import CompanyContacts from '../components/CompanyDetail/CompanyContacts.vue';
import CompanyEvents from '../components/CompanyDetail/CompanyEvents.vue';
import CompanyJobPositions from '@/components/CompanyDetail/CompanyJobPositions.vue';
import CompanyCriminalRecord from '@/components/CompanyDetail/CompanyCriminalRecord.vue';

export default {
    components: {
        CompanyBasicInfo,
        CompanyOwners,
        CompanyDph,
        CompanyBankAcc,
        CompanyTrades,
        CompanyYourInfo,
        CompanyNotes,
        CompanyExecutions,
        CompanyInsolvency,
        CompanyBasicCapital,
        CompanyEstablishments,
        BaseTemplate,
        SpinningWheel,
        CompanyDocuments,
        CompanyContacts,
        CompanyEvents,
        CompanyJobPositions,
        CompanyCriminalRecord
    },
    data() {
        return {
            company: {},
            filter: {},
            institution: {},
            tags: [],
            companyAddress: [],
            error: false,
            loading: 0,
            contacts: [],
            events: [],
            jobPositions: [],
            activeTab: 'zakladni',
            actualOWnersCount: null,
            oldOwnersCount: null
        }
    },
    created: function () {
        this.loadData();
    },
    methods: {
        loadData: function () {
            this.loading = 2;
            this.$store.getters.api.get('/company/' + this.$route.params.slug).then(function (response) {
                this.company = response.data.item;
                const data = response.data;
                if (data.error_code == 401) {
                    this.error = (this.$t("error.401"));
                }
            }.bind(this))
                .finally(function () {
                    this.loading -= 1;
                }.bind(this));
            if (this.$store.getters.selectedInstitution) {
                const institutionId = this.$store.getters.selectedInstitution;
                this.$store.getters.api.get(`/institution/${institutionId}`).then(function (response) {
                    this.institution = response.data.institution;
                }.bind(this));
            }
            this.$store.getters.api.get('/company/' + this.$route.params.slug + '/job-positions').then(function (response) {
                this.jobPositions = response.data.items;
            }.bind(this));
            this.$store.getters.api.get('/company/' + this.$route.params.slug + '/address').then(function (response) {
                this.companyAddress = response.data.items;
            }.bind(this))
                .finally(function () {
                    this.loading -= 1;
                }.bind(this));
            this.$store.getters.api.get(`/company/${this.$route.params.slug}/owners`).then((response) => {
                this.actualOWnersCount = response.data.current_owners_count;
                this.oldOwnersCount = response.data.old_owners_count;
            });
        },
        getTags() {
            this.$store.getters.api.get(`institution/${this.$store.getters.selectedInstitution}/tags`).then(function (response) {
                this.tags = response.data.items;
            }.bind(this))
        },
        getContacts() {
            this.$store.getters.api.get(`/company/${this.$route.params.slug}/company_contact`)
                .then(response => {
                    this.contacts = response.data;
                })
        },
        getEvents() {
            this.$store.getters.api.get(`/company/${this.$route.params.slug}/events`)
                .then(response => {
                    this.events = response.data;
                })
        },
    },
    watch: {
        activeTab(newTab, oldTab) {
            if (newTab === 'kontakty') {
                this.getContacts();
            }
            if (newTab === 'udalosti') {
                this.getEvents();
            }
            if (newTab === 'vase' && this.tags.length === 0) {
                this.getTags();
            }
        }
    }
}
</script>

<style scoped lang="scss">
@import "@/scss/abstracts/variables";
@import "@/scss/base/typography.scss";

.tabs {
    background: conic-gradient(from 90deg at 50% 50%, #B71564 -122.4deg, #890C70 95.4deg, #B71564 237.6deg, #890C70 455.4deg);
    box-shadow: 2px 4px 5px rgba(0, 0, 0, 0.5);
    border-radius: 50px;

    .custom-pills .nav-item {
        width: 220px;
        text-align: center;
        background: $dark-purple;
        box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.3);
        border-radius: 50px;
    }

    .custom-pills .nav-link {
        color: $white;
        font-weight: 700;
        cursor: pointer;
    }

    .custom-pills .nav-link.active {
        border: $white 1px solid;
        background: $dark-purple;
        border-radius: 50px;
    }

    .custom-pills .nav-link.disabled {
        cursor: not-allowed;
        opacity: 0.5;
    }
}

.hidden {
    display: none;
    margin-top: 0;
}

.company {
    background-color: transparent;
    position: relative;
}

.loading-company {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 10000;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.7);
}

#map {
    height: 180px;
}
</style>